export class CommonHelper {

   public static validUrl = (url: any): any => {
       
        try {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?', 'i'); // query string
            return !!pattern.test(url);
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    public static checkIfContainHttps = (url: any): any => {
        
        if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1)  {
            url = "https://" + url;
        }

        return url;
    }

}

